/** Mirrors Task Hub “days overdue” styling: none / short / long. */
export function overviewOverdueTagColor(days: number): string {
  if (days <= 0) return "#237804";
  if (days <= 7) return "#d46b08";
  return "#cf1322";
}
